import React from 'react';
import { TableProps } from 'antd/lib/table';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { Table } from 'antd';
import './table.scss';

interface TableComponentProps extends TableProps<any> {
    onClickEvent?: (event: React.MouseEvent<HTMLElement>) => void;
    onChangeEvent?: (pagination: TablePaginationConfig, filters: Record<string, any>, sorter: any) => void;
    elipsis?: boolean;
    components?: any;
}


//https://ant.design/components/table#table
const TableComponent = (props: TableComponentProps) => {
    const {
        components,
        columns,
        dataSource,
        showSorterTooltip,
        scroll,
        className,
        onClickEvent,
        onChangeEvent,
        style,
        onRow,
        summary,
        loading,
        pagination,
        expandable,
        rowClassName,
        rowKey,
        elipsis,
        bordered,
        size,
        locale
    } = props;
    return (
        <Table
            components={components}
            columns={columns}
            dataSource={dataSource}
            showSorterTooltip={showSorterTooltip}
            scroll={scroll}
            className={className}
            onChange={onChangeEvent}
            style={style}
            onRow={onRow}
            summary={summary}
            loading={loading}
            pagination={pagination}
            expandable={expandable}
            rowClassName={rowClassName}
            rowKey={rowKey}
            // elipsis={elipsis}
            bordered={bordered}
            size={size}
            locale={locale}
        />
    );
};

export default TableComponent;
